export class LeadSourceApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createLeadSource(body) {
    return this.#http.post('/leadSource', body);
  }

  async editLeadSource({ leadSourceId, ...body }) {
    return this.#http.put(`/leadSource/${leadSourceId}`, body);
  }

  async deleteLeadSource({ leadSourceId }) {
    return this.#http.delete(`/leadSource/${leadSourceId}`);
  }

  async getLeadSourceList({ applicationId } = {}) {
    return this.#http.get('/leadSource/list', { params: { applicationId } });
  }

  async createLeadSourceLogo({ formData }) {
    return this.#http.post('/LeadSource/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
